'use client';

import { Language, Subsidiary } from '@coolblue-development/constants';
import { Box } from '@coolblue-development/freddy';

import { CountryLanguageOptions } from '../constants';
import { LanguageOption } from '../LanguageOption';
import { SubsidiaryOption } from '../SubsidiaryOption';

type Props = {
  allLanguageOptions: Partial<CountryLanguageOptions>;
  isVacancyPage: boolean;
  pageLanguage: Language;
  pageSubsidiary: Subsidiary;
  isHamburgerVariant: boolean;
  showAllLanguageOptions?: boolean;
  setShowAllLanguageOptions?: (showAllLanguageOptions: boolean) => void;
};

export const LanguageOptionsList = ({
  allLanguageOptions,
  isVacancyPage,
  pageLanguage,
  pageSubsidiary,
  isHamburgerVariant,
  showAllLanguageOptions = true,
  setShowAllLanguageOptions
}: Props) => {
  const filteredLanguageOptions = showAllLanguageOptions
    ? allLanguageOptions
    : { [pageSubsidiary]: allLanguageOptions[pageSubsidiary] };

  const languagePickerOptions = Object.entries(filteredLanguageOptions).map(
    ([subsidiary, options = []]) => {
      return (
        <Box key={subsidiary}>
          <SubsidiaryOption
            subsidiary={subsidiary as Subsidiary}
            pageSubsidiary={pageSubsidiary}
            pageLanguage={pageLanguage}
            isVacancyPage={isVacancyPage}
            showAllLanguageOptions={showAllLanguageOptions}
            setShowAllLanguageOptions={setShowAllLanguageOptions}
          />
          {options.map(langOption => {
            const isEnabled = langOption.slug || langOption.language === pageLanguage;
            const isSelected =
              langOption.language === pageLanguage && subsidiary === pageSubsidiary;
            return (
              <LanguageOption
                key={`${subsidiary}-${langOption.language}`}
                selectedLanguage={langOption.language}
                languageOptionText={langOption.languageOptionText || ''}
                slug={langOption.slug}
                isDisabled={!isEnabled}
                isHamburgerVariant={isHamburgerVariant}
                isSelected={isSelected}
                selectedSubsidiary={subsidiary as Subsidiary}
              />
            );
          })}
        </Box>
      );
    }
  );

  return <>{languagePickerOptions}</>;
};
